import { Component, inject, signal } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { AuthService } from 'src/app/shared/services/auth/auth.service';
import { HeaderAppComponent } from '../../headers/header-app/header-app.component';
import { FormTemplateComponent } from '../../../shared/screen-templates/form-template/form-template.component';
import { PayeeHorizontalLineComponent } from '../../../shared/payee-horizontal-line/payee-horizontal-line.component';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-get-password-link-success',
  templateUrl: './get-password-link-success.component.html',
  styleUrls: ['./get-password-link-success.component.scss'],
  imports: [
    HeaderAppComponent,
    FormTemplateComponent,
    PayeeHorizontalLineComponent,
    MatProgressSpinner,
    TranslateModule,
  ],
})
export class GetPasswordLinkSuccessComponent {
  private authService = inject(AuthService);
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private snackbar = inject(MatSnackBar);
  private translate = inject(TranslateService);

  readonly loading = signal(false);
  emailSent = false;

  readonly email: string;

  constructor() {
    this.email = this.route.snapshot.queryParams.email;

    if (!this.email) {
      this.router.navigateByUrl('/login');
    }
  }

  async resendForgotPasswordEmail() {
    if (this.loading() || this.emailSent) {
      return;
    }

    try {
      this.loading.set(true);
      this.emailSent = true;
      await this.authService.sendPasswordResetEmail({
        email: this.email,
      });
      this.snackbar.open(
        this.translate.instant('GET_PASSWORD_RESET_LINK_SUCCESS.EMAIL_SENT'),
        this.translate.instant('OK'),
        {
          duration: 5000,
        },
      );
    } finally {
      this.loading.set(false);
      setTimeout(() => (this.emailSent = false), 15000);
    }
  }
}
